import {
  BackupListV2200,
  SitesBackupsDetails200,
} from '@newfold/huapi-js/src/index.schemas';

export const BackupsV2: BackupListV2200 = {
  backups: [
    {
      backup_id: 'b579a275-184b-4e46-aacf-e6cd86e690a7',
      backup_creation_time: '1752075550',
      type: 'Historic',
      databases: ['tfvogkte_billing', 'tfvogkte_foundation'],
      schedule_type: 'weekly',
    },
    {
      backup_id: 'af1d7af1-b48b-44e1-a109-a58b6d3c9393',
      backup_creation_time: '1752075550',
      type: 'manual',
      databases: ['tfvogkte_billing', 'tfvogkte_foundation'],
      schedule_type: 'weekly',
    },
  ],
};

export const metaDataV2 = {
  account: {
    cbs_last_restore_timestamp: null,
    cbs_event_processing: {
      client_tracking_id: '20f8b605-17ec-443f-af88-0db49bec85f9',
      site_id: 388778,
      snapshot_date: 1765173181,
      action: 'backup_pre_restore',
      type: 'home',
      internal_tracking_id: 1554,
      backup_id: 'cb80966c-8ceb-4cd3-b67c-9691d593e2cc',
    },
    cbs_downloadables: [],
  },
  site: {
    cbs_restore_consent_info: {
      backup_type: 'home',
      current_state_backup_download_url:
        'https://objectstorage.us-ashburn-1.oraclecloud.com/p/YHwy-GWhfn80BByyHTRnBL4IShavcq9o4-juPwQaO6go-kKcTSbdyoIREi3BSKUP/n/id66bfvx1x44/b/bedrock-us-ashburn-1-shared-backups-bucket/o/ondemand_backups/rilykjte_partial_1552.tar.gz',
      current_state_backup_id: 'af1d7af1-b48b-44e1-a109-a58b6d3c9393',
      internal_tracking_id: 1554,
      restore_status: 'backup_pre_restore_started',
    },
    cbs_downloadables: [
      {
        type: 'db',
        snapshot_date: 1765289144,
        time_req_completed: 1765298462,
        tracking_id: 1553,
        url: 'https://objectstorage.us-ashburn-1.oraclecloud.com/p/DBGORjFb0EDLgU_iKwXmZHHDQiNSLOeuCKJ0WmgS6JPwFds7kfgzeuAOy7yQPrlw/n/id66bfvx1x44/b/bedrock-us-ashburn-1-shared-backups-bucket/o/ondemand_backups/rilykjte_partial_1552.tar.gz',
      },
      {
        type: 'home',
        snapshot_date: 1765211955,
        time_req_completed: 1765288927,
        tracking_id: 1551,
        url: 'https://objectstorage.us-ashburn-1.oraclecloud.com/p/GReuDISHbqC3luy-Pg_28P6Qcbdi3bGVvZcpVnanP47P9Mg6UXthdxaQ8-s2-I4j/n/id66bfvx1x44/b/bedrock-us-ashburn-1-shared-backups-bucket/o/ondemand_backups/rilykjte_partial_1551.tar.gz',
      },
    ],
  },
};

/** Jetpack backup with an active addon — renders the main card */
export const jetpackActiveResponse: SitesBackupsDetails200 = {
  jetpack: {
    addon_id: '123456',
    plugin_exists: true,
    addon_exists: true,
    has_active_addon: true,
    has_active_plugin: true,
    plan_name: 'Jetpack Backup Premium',
    status: 'active',
    last_backup_date: '2024-07-24 19:32:19',
    next_url: null,
    pending_upgrade: false,
    can_purchase: false,
    can_upgrade: true,
    addon_back_reference: 'WN.HP.000000000',
    last_error: null,
  },
};

/** Jetpack response with no addon_id — triggers PurchaseJetpack */
export const jetpackNoAddonResponse: SitesBackupsDetails200 = {
  jetpack: {
    plugin_exists: true,
    addon_exists: false,
  },
};

/** Jetpack response with deleted status — also triggers PurchaseJetpack */
export const jetpackDeletedResponse: SitesBackupsDetails200 = {
  jetpack: {
    addon_id: '123456',
    status: 'deleted',
    plugin_exists: true,
    addon_exists: true,
    has_active_addon: false,
    has_active_plugin: false,
    plan_name: 'Jetpack Backup Premium',
  },
};

/** Jetpack response that triggers the already_registered JetpackDialog */
export const jetpackAlreadyRegisteredResponse: SitesBackupsDetails200 = {
  jetpack: {
    addon_id: '123456',
    plugin_exists: true,
    addon_exists: true,
    has_active_addon: true,
    has_active_plugin: true,
    plan_name: 'Jetpack Backup Premium',
    status: 'active',
    last_backup_date: '2024-07-24 19:32:19',
    last_error: 'already_registered',
    next_url: null,
    pending_upgrade: false,
    can_purchase: false,
    can_upgrade: true,
    addon_back_reference: 'WN.HP.000000000',
  },
};
